(function () {
    'use strict';

    angular
        .module('franchisee-portal.components')
        .controller('HelpdeskInternalController', HelpdeskInternalController);

    /** @ngInject */
    function HelpdeskInternalController($scope, $stateParams, $rootScope, $state, $q, HelperService, HelpdeskService, AuthenticationService, PersonService, NotifyService, UnitService, sweetAlert, DATA_EVENTS, ROUTES) {
        const vm = this;

        let userData;
        let userUnits;
        let isFranchisee;
        let ticketOriginalData = {};
        let ticketCategoryOriginalData;
        let ticketResponsibleOriginalData;
        let ticketStatusOriginalData;
        let lastResponse = {};
        let units = [];

        // ÁREA CUSTOM METHODS
        vm.isTicketModified = (isEdit = false) => {
            if (!isEdit) {
                return vm.ticketData.Id &&
                    !angular.equals(vm.selectedStatus, ticketStatusOriginalData) ||
                    vm.response != null;
            }

            return vm.ticketData.Id &&
                !angular.equals(vm.ticketData, ticketOriginalData) ||
                !angular.equals(vm.selectedCategory, ticketCategoryOriginalData) ||
                !angular.equals(vm.selectedResponsible, ticketResponsibleOriginalData);
        }

        vm.isTicketClosed = () => {
            if (!vm.ticketData.IsClosed)
                return;

            return vm.ticketData.IsClosed;
        }

        vm.hasEditPermission = () => {
            if (!vm.ticketData.Id)
                return true;

            let hasPermission = false;

            if (vm.ticketData.TicketCategory) {
                let categoryPerson = vm.ticketData.TicketCategory.TicketCategory_Person;

                for (let index = 0; index < categoryPerson.length; index++) {
                    if (categoryPerson[index].PersonId == userData.Id) {
                        hasPermission = true;
                    }
                }
            }

            return hasPermission;
        }

        vm.showSelectUnit = () => {
            return (AuthenticationService.isFranchisee() && userUnits.length > 1) || !AuthenticationService.isFranchisee();
        }

        // FILE UPLOAD
        vm.flowFileAdded = $file => {
            let blacklist = ['exe', 'bat', 'com', 'sis', 'dll', 'js', 'msi', 'cmd', 'hta', 'scr', 'pif', 'reg', 'vbs', 'wsf', 'cpl', 'jar'];
            let extension = $file.getExtension();

            if (blacklist.includes(extension)) {
                HelperService.setErrorMessageForm('.file', 'Formato inválido.');
                return false;
            }

            HelperService.removeErrorMessageForm('.file');
        }

        vm.flowFileFinished = ($file, $message) => {
            var message = angular.fromJson($message);
            let file = {
                TicketId: vm.ticketData.Id,
                Name: message.FileName,
                Url: message.FileSaveName
            };

            HelperService.startLoading('.loading-holder');

            saveTicketAttachments(file)
                .then(
                    success => {
                        file.Id = success.Id;
                        vm.files.push(file);

                        vm.ticketData.Attachment = file;
                        vm.saveResponse();
                    }, error => errorCallback(error)
                );
        }

        vm.deleteFile = file => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.loading-holder');

                    HelpdeskService
                        .deleteAttachment(file.Id, file.Url)
                        .then(() => {
                            var index = vm.files.indexOf(file);

                            if (index != -1)
                                vm.files.splice(index, 1);

                            vm.ticketData.Attachment = file;
                            vm.ticketData.Attachment.Deleted = true;
                            vm.saveResponse();

                            ticketOriginalData = angular.copy(vm.ticketData);
                        }, error => {
                            HelperService.errorCallback(error);
                            HelperService.stopLoading('.loading-holder');
                        })
                }
            })
        }

        vm.getFileIcon = file => {
            return HelperService.imageHandlerFileIcon(file.Url.split('.').pop());
        }

        vm.getFileUrl = file => {
            return HelperService.fileHandlerPath(`ticket/${vm.ticketData.Id}`, file.Url);
        }

        vm.saveTicket = () => {
            if (!vm.selectedCategory) {
                HelperService.setErrorMessageForm('.category');
                return;
            }

            HelperService.startLoading('.loading-holder');

            let ticketData = angular.copy(vm.ticketData);

            ticketData.TicketCategoryId = vm.selectedCategory.Id;
            ticketData.ResponsiblePersonId = vm.selectedResponsible ? vm.selectedResponsible.Id : null;

            if (!vm.ticketData.Id) {
                let unitData = AuthenticationService.getSelectedUnit();

                if (!vm.ticketData.CallerPhone)
                    vm.ticketData.CallerPhone = '';

                if (vm.selectedUnit)
                    unitData = vm.selectedUnit;

                ticketData.PersonId = userData.Id;

                ticketData.UnitId = unitData.Id;
                ticketData.UnitFantasyName = unitData.FantasyName;
                ticketData.UnitExternalCode = unitData.ExternalCode;

                ticketData.TicketTimeline = [{
                    TicketStatusId: 1,
                    PersonId: AuthenticationService.getUserId(),
                    Text: vm.response ? vm.response : 'Abertura de chamado.'
                }];

                HelpdeskService
                    .postTicket(ticketData)
                    .then(success => successCallback(success, false, true), error => errorCallback(error));
            } else {
                HelpdeskService
                    .putTicket(ticketData)
                    .then(() => vm.saveResponse(true), error => errorCallback(error));
            }
        }

        vm.saveResponse = (showLoading = false) => {
            if (showLoading)
                HelperService.startLoading('.loading-holder');

            let timeline = {
                TicketId: vm.ticketData.Id,
                TicketStatusId: vm.selectedStatus.Id,
                PersonId: AuthenticationService.getUserId()
            };

            let text = "";

            if (vm.ticketData.Attachment) {
                if (!vm.ticketData.Attachment.Deleted)
                    text = text.concat(`<p>Novo anexo adicionado: <b>${vm.ticketData.Attachment.Name}</b></p>`);
                else
                    text = text.concat(`<p>Anexo deletado: <b>${vm.ticketData.Attachment.Name}</b></p>`);
            }

            if (!angular.equals(vm.ticketData.Title, ticketOriginalData.Title))
                text = text.concat(`<p>Título alterado de: <b>${ticketOriginalData.Title}</b> para: <b>${vm.ticketData.Title}</b></p>`);

            if (!angular.equals(vm.ticketData.TicketCategoryId, vm.selectedCategory.Id))
                text = text.concat(`<p>Categoria alterada de: <b>${ticketOriginalData.TicketCategory.Title}</b> para: <b>${vm.selectedCategory.Title}</b></p>`);

            if (!angular.equals(vm.ticketData.ResponsiblePersonId, vm.selectedResponsible.Id))
                text = text.concat(`<p>Responsável alterado de: <b>${ticketOriginalData.Person1 != null ? ticketOriginalData.Person1.Name : '-'}</b> para: <b>${vm.selectedResponsible.Name}</b></p>`);

            if (!angular.equals(lastResponse.TicketStatusId, vm.selectedStatus.Id)) {
                let oldStatus = vm.status.find(x => x.Id == lastResponse.TicketStatusId);
                text = text.concat(`<p>Status alterado de: <b>${oldStatus.Title}</b> para: <b>${vm.selectedStatus.Title}</b></p>`);
            }

            if (vm.response)
                text = text.concat(vm.response);

            timeline.Text = text;

            HelpdeskService
                .postTimeline(timeline, userData.Id)
                .then(success => successCallback(success, true), error => errorCallback(error));
        }

        vm.closeTicket = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.loading-holder');

                    let timeline = {
                        TicketId: vm.ticketData.Id,
                        TicketStatusId: 4,
                        PersonId: AuthenticationService.getUserId(),
                        Text: '<p><b>TICKET FECHADO PELO FRANQUEADO.</b></p>'
                    };

                    if (userData.Id != vm.ticketData.PersonId)
                        timeline.Text = '<p><b>TICKET FECHADO.</b></p>';

                    HelpdeskService
                        .postTimeline(timeline, userData.Id)
                        .then(success => {
                            let newResponse = {
                                Id: success.Id,
                                Person: userData,
                                Text: success.Text,
                                RegistrationDate: success.RegistrationDate
                            };

                            vm.timeline.unshift(newResponse);

                            vm.ticketData.IsClosed = true;

                            NotifyService.success("Chamado fechado com sucesso.");
                            HelperService.stopLoading('.loading-holder');
                        }, error => errorCallback(error));
                }
            })
        }

        vm.openUnitModal = () => {
            HelperService.startLoading('.loading-holder');

            getUnit(vm.ticketData.UnitId)
                .then(() => {
                    $('#unitModal').modal('show');

                    HelperService.stopLoading('.loading-holder');
                });
        }

        vm.getPersonImage = person => {
            if (person.Image)
                return `${ROUTES.CENTRAL_CONTAS}api/images/res/150/150/person/${person.ExternalId}/${person.Image}`;

            return `${ROUTES.CENTRAL_CONTAS}api/images/res/100/100/placeholder.jpg`;
        }

        vm.assignTicket = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Você será atribuido como responsável por esse chamado.',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    vm.selectedResponsible = vm.people.find(person => person.Id == userData.Id);
                    vm.saveTicket();
                }
            })
        }

        vm.getUnits = search => {
            if (isFranchisee) return;

            if (!search) {
                vm.units = [];
                return;
            }

            vm.units = units.filter(unit => filterUnit(unit, search));
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            init();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function saveTicketAttachments(attachment) {
            return HelpdeskService
                .postAttachment(attachment);
        }

        function getTicket() {
            const ticketId = $stateParams.ticketId;
            const personId = AuthenticationService.getUserId();

            if (!ticketId) {
                vm.ticketData.CallerName = userData.Name;
                vm.ticketData.CallerEmail = userData.Email;
                vm.ticketData.CallerPhone = userData.Phone;

                ticketOriginalData = angular.copy(vm.ticketData);
                HelperService.stopLoading('.loading-holder');
                return;
            }

            HelpdeskService
                .getById(ticketId, personId)
                .then(success => {
                    vm.ticketData = success;

                    vm.ticketData.RegistrationDateFormatted = moment(vm.ticketData.RegistrationDate).format('DD-MM-YYYY H:mm:ss');

                    lastResponse = vm.ticketData.TicketTimeline[vm.ticketData.TicketTimeline.length - 1];

                    vm.selectedCategory = vm.categories.find(y => y.Id == vm.ticketData.TicketCategoryId);

                    vm.selectedResponsible = vm.ticketData.Person1;

                    vm.selectedUnit = units.find(unit => unit.Id == vm.ticketData.UnitId);

                    if (lastResponse) {
                        vm.selectedStatus = vm.status.find(x => x.Id == lastResponse.TicketStatusId);
                        vm.ticketData.AtualizationDateFormatted = moment(lastResponse.RegistrationDate).format('DD-MM-YYYY H:mm:ss');
                    }

                    if (vm.selectedStatus.Id == 4)
                        vm.ticketData.IsClosed = true;

                    if (vm.ticketData.TicketAttachment.length)
                        vm.files = vm.ticketData.TicketAttachment;

                    if (vm.ticketData.TicketTimeline.length)
                        vm.timeline = angular.copy(vm.ticketData.TicketTimeline.reverse());

                    ticketOriginalData = angular.copy(vm.ticketData);
                    ticketCategoryOriginalData = angular.copy(vm.selectedCategory);
                    ticketResponsibleOriginalData = angular.copy(vm.selectedResponsible);
                    ticketStatusOriginalData = angular.copy(vm.selectedStatus);

                    getPeople(vm.selectedCategory.Id)
                        .then(() => HelperService.stopLoading('.loading-holder'));
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                })
        }

        function getCategories() {
            return HelpdeskService
                .getAllCategories()
                .then(success => vm.categories = success.filter(category => category.Id != 2),
                    error => HelperService.errorCallback(error));
        }

        function getStatus() {
            return HelpdeskService
                .getAllStatus()
                .then(success => vm.status = success,
                    error => HelperService.errorCallback(error));
        }

        function getPeople(ticketCategoryId) {
            return PersonService
                .getAllByTicketCategory(ticketCategoryId)
                .then(success => vm.people = success,
                    error => HelperService.errorCallback(error));
        }

        function getUnits() {
            if (isFranchisee) {
                vm.units = userUnits;
                units = userUnits;
            } else {
                return UnitService
                    .getAll()
                    .then(success => units = success,
                        error => HelperService.errorCallback(error));
            }
        }

        function getUnit(unitId) {
            return UnitService
                .get(unitId)
                .then(success => {
                    if (success.Unit_Address.length)
                        success.Unit_Address = success.Unit_Address[0];
                    else
                        success.Unit_Address = null;

                    if (success.Unit_Document.length)
                        success.Unit_Document = success.Unit_Document.find(x => x.DocumentTypeId == 5);
                    else
                        success.Unit_Document = null;

                    if (success.Unit_Email.length)
                        success.Unit_Email = success.Unit_Email[0];
                    else
                        success.Unit_Email = null;

                    if (success.Unit_Phone.length)
                        success.Unit_Phone = success.Unit_Phone.find(x => x.Code && x.Number);
                    else
                        success.Unit_Phone = null;

                    vm.unitData = success;
                }, error => HelperService.errorCallback(error));
        }

        function filterUnit(unit, search) {
            if (unit.FantasyName == null)
                unit.FantasyName = '';

            if (unit.FantasyName.toLowerCase().includes(search.toLowerCase()))
                return unit;
        }

        function successCallback(success, isAtualization = false, isPost = false) {
            if (isPost) {
                HelperService.successCallback();

                vm.ticketData = success;

                ticketOriginalData = angular.copy(vm.ticketData);
                ticketCategoryOriginalData = angular.copy(vm.selectedCategory);
                ticketStatusOriginalData = angular.copy(vm.selectedStatus);

                $state.go('app-master.default.helpdesk-internal', {
                    ticketId: vm.ticketData.Id
                }, {
                    notify: false
                });
            } else {
                if (isAtualization) {
                    let newResponse = {
                        Id: success.Id,
                        Person: userData,
                        Text: success.Text,
                        RegistrationDate: success.RegistrationDate
                    };

                    vm.timeline.unshift(newResponse);
                }

                vm.response = null;

                ticketOriginalData = angular.copy(vm.ticketData);
                ticketCategoryOriginalData = angular.copy(vm.selectedCategory);
                ticketStatusOriginalData = angular.copy(vm.selectedStatus);

                NotifyService.success("Ticket atualizado com sucesso. Aguarde uma nova interação.");
            }

            HelperService.stopLoading('.loading-holder');
        }

        function errorCallback(error) {
            HelperService.stopLoading('.loading-holder');
            HelperService.errorCallback(error);
        }

        function initVars() {
            userData = AuthenticationService.getUserData();
            userUnits = AuthenticationService.getUnits();
            isFranchisee = AuthenticationService.isFranchisee();

            vm.ticketData = {};
            vm.people = [];
            vm.units = [];
            vm.files = [];

            vm.flowOptions = {
                query: function () {
                    return {
                        Path: `ticket/${vm.ticketData.Id}`
                    }
                }
            }

            angular.extend(vm.flowOptions, HelperService.getFlowOptionsDefaultsFile());
        }

        function init() {
            initVars();

            HelperService.startLoading('.loading-holder');

            $q.all([getCategories(), getStatus(), getUnits()])
                .then(() => {
                    getTicket();
                })
        }
    }
}());